<template>
  <div class="card-form">
    <div class="card-list">
      <Card
        :fields="fields"
        :labels="formData"
        :isCardNumberMasked="isCardNumberMasked"
        :randomBackgrounds="randomBackgrounds"
        :backgroundImage="backgroundImage"
      />
    </div>

    <div class="card-form__inner">

      <!-- VALOR TOTAL -->
      <div class="card-form__valor" v-if="isSale">
        Total da assinatura
        <strong>
          R$ {{ formatValor(valor) }}
        </strong>
      </div>

      <!-- PARCELAS -->
      <div class="card-form__row">
        <div class="card-form__col">
          <div class="card-form__group">
            <label class="card-input__label">
              Parcelamento
            </label>

            <select
              class="card-input__input -select"
              v-model="formData.cardVezes"
            >
              <option value disabled selected>Parcelas</option>

              <option
                v-for="n in vezesByPlan"
                :key="n"
                :value="n"
              >
                {{ generateVezes(n) }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <!-- NUMERO -->
      <div class="card-input">
        <label class="card-input__label">
          Número do cartão
        </label>

        <input
          type="tel"
          class="card-input__input"
          :value="formData.cardNumber"
          :maxlength="cardNumberMaxLength"
          @input="changeNumber"
        />
      </div>

      <!-- TITULAR -->
      <div class="card-input">
        <label class="card-input__label">
          Nome do titular
        </label>

        <input
          type="text"
          class="card-input__input"
          v-letter-only
          :value="formData.cardName"
          @input="changeName"
        />
      </div>

      <!-- DATA -->
      <div class="card-form__row">

        <div class="card-form__col">

          <label class="card-input__label">
            Validade
          </label>

          <select
            class="card-input__input -select"
            v-model="formData.cardMonth"
            @change="changeMonth"
          >
            <option disabled>Mês</option>

            <option
              v-for="n in 12"
              :key="n"
              :value="n < 10 ? '0'+n : n"
            >
              {{ generateMonthValue(n) }}
            </option>

          </select>

          <select
            class="card-input__input -select"
            v-model="formData.cardYear"
            @change="changeYear"
          >
            <option disabled>Ano</option>

            <option
              v-for="(n,i) in 12"
              :key="i"
              :value="minCardYear+i"
            >
              {{ minCardYear+i }}
            </option>

          </select>

        </div>

        <div class="card-form__col -cvv">

          <div class="card-input">

            <label class="card-input__label">
              CVV
            </label>

            <input
              type="tel"
              class="card-input__input"
              maxlength="3"
              v-number-only
              :value="formData.cardCvv"
              @input="changeCvv"
            />

          </div>

        </div>

      </div>

      <!-- BOTÃO -->
      <button
        class="card-form__button"
        @click="postCard"
      >
        {{ isSale ? "Realizar assinatura" : "Atualizar dados" }}
      </button>

    </div>
  </div>
</template>

<script>
import Card from "./Card"
import { mapActions } from "vuex"

export default {

  name: "CardForm",

  components: { Card },

  directives: {

    "number-only": {
      bind(el){
        el.addEventListener("keypress",(e)=>{
          if(e.charCode < 48 || e.charCode > 57) e.preventDefault()
        })
      }
    },

    "letter-only":{
      bind(el){
        el.addEventListener("keypress",(e)=>{
          if(e.charCode >= 48 && e.charCode <= 57) e.preventDefault()
        })
      }
    }

  },

  props: {

    formData:{
      type:Object,
      default:()=>({
        cardName:"",
        cardNumber:"",
        cardMonth:"",
        cardYear:"",
        cardCvv:"",
        cardVezes:1
      })
    },

    valor:{
      type:[Number,String],
      default:0
    },

    plano:String,
    id_plan:String,

    vezesByPlan:{
      type:Number,
      default:1
    },

    isSale:{
      type:Boolean,
      default:false
    },

    appsRenovacao:{
      type:Array,
      default:()=>[]
    },

    backgroundImage:[String,Object],
    randomBackgrounds:{
      type:Boolean,
      default:true
    }

  },

  data(){

    return{

      fields:{
        cardNumber:"v-card-number",
        cardName:"v-card-name",
        cardMonth:"v-card-month",
        cardYear:"v-card-year",
        cardCvv:"v-card-cvv"
      },

      minCardYear:new Date().getFullYear(),

      cardNumberMaxLength:19,

      isCardNumberMasked:true

    }

  },

  mounted(){

    if(!this.formData.cardVezes){
      this.formData.cardVezes = this.vezesByPlan
    }

  },

  methods:{

    ...mapActions(["setLoading"]),

    formatValor(v){
      return Number(v).toLocaleString("pt-BR",{minimumFractionDigits:2})
    },

    generateMonthValue(n){
      return n < 10 ? `0${n}` : n
    },

    valorParcela(n){

      const total = Number(this.valor || 0)

      if(!n || !total) return "0,00"

      const parcela = total / n

      return parcela.toLocaleString("pt-BR",{
        minimumFractionDigits:2,
        maximumFractionDigits:2
      })

    },

    generateVezes(n){

      return `${n}x R$ ${this.valorParcela(n)}`

    },

    changeName(e){
      this.formData.cardName = e.target.value
      this.$emit("input-card-name",this.formData.cardName)
    },

    changeNumber(e){

      let value = e.target.value.replace(/\D/g,"")

      this.formData.cardNumber = value
        .replace(/(\d{4})/g,"$1 ")
        .trim()

      this.$emit("input-card-number",this.formData.cardNumber)

    },

    changeMonth(){
      this.$emit("input-card-month",this.formData.cardMonth)
    },

    changeYear(){
      this.$emit("input-card-year",this.formData.cardYear)
    },

    changeCvv(e){
      this.formData.cardCvv = e.target.value
      this.$emit("input-card-cvv",this.formData.cardCvv)
    },

    async postCard(){

      if(!this.formData.cardName){
        this.$toast.warning("Preencha o nome do titular")
        return
      }

      if(!this.formData.cardNumber){
        this.$toast.warning("Preencha o número do cartão")
        return
      }

      if(!this.formData.cardMonth){
        this.$toast.warning("Preencha o mês")
        return
      }

      if(!this.formData.cardYear){
        this.$toast.warning("Preencha o ano")
        return
      }

      if(!this.formData.cardCvv){
        this.$toast.warning("Preencha o CVV")
        return
      }

      const dadosCartao = {

        numero:this.formData.cardNumber.replace(/ /g,""),

        numero_mascara:this.formData.cardNumber,

        nome:this.formData.cardName,

        mes:this.formData.cardMonth,

        ano:this.formData.cardYear,

        cvv:this.formData.cardCvv,

        vezes:this.formData.cardVezes,

        valor:this.valor,

        id_plan:this.id_plan,

        apps_renovacao:this.appsRenovacao,

        is_sale:this.isSale

      }

      try{

        this.setLoading(true)
        
        const response = await this.$http.post("/empresa/cartao", dadosCartao)

        this.$toast.success("Pagamento realizado com sucesso!")

        this.$emit("card-success", {
          dadosCartao,
          response: true
        })

      }
      catch(e){

        this.$toast.warning("Erro ao processar pagamento")

      }
      finally{

        this.setLoading(false)

      }

    }

  }

}
</script>

<style scoped>

.card-form__valor{

  text-align:center;

  font-size:18px;

  font-weight:700;

  margin-bottom:20px;

  color:#ee7361;

}

.card-form__valor strong{

  display:block;

  font-size:22px;

}

</style>
